import Vue from "vue";
import moment from "moment";
import VueMoment from "vue-moment";
require("moment/locale/fr");

Vue.use(VueMoment, {
    moment
});

export default moment;